var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M15.926 20H10.5c0 1.519 1.215 2.75 2.713 2.75s2.713-1.231 2.713-2.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M22.135 16.567c-.82-.892-2.353-2.234-2.353-6.63 0-3.338-2.31-6.01-5.426-6.667v-.895C14.356 1.615 13.75 1 13 1c-.749 0-1.356.616-1.356 1.375v.895c-3.116.656-5.426 3.33-5.426 6.668 0 4.395-1.533 5.737-2.353 6.63a1.351 1.351 0 00-.365.932c.005.705.55 1.375 1.361 1.375H21.14c.81 0 1.357-.67 1.36-1.375a1.35 1.35 0 00-.364-.933z"
  }))));
}

export default SvgBell;